import { useDispatch, useSelector } from "react-redux"
import { CompanyForm } from "./CompanyForm"
import { RootState } from "src/state/reducer"
import { Company } from "src/common/models/company"
import { useState } from "react"
import { CancelConfirmationModal } from "src/common/descriptions/components/cancelConfirmationModal"
import { ModalSuccess } from "src/components/ModalSuccess"
import { Loader } from "src/components/Loader"
import { SystemDescriptions } from "src/common/descriptions"
import { useNavigate } from "react-router"
import { Urls } from "src/common/urls"
import { updateCompanyDataApi } from "src/common/state/action"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { UPDATE_COMPANY_DATA_API } from "src/common/state/actionTypes"

interface ReduxProps {
    company?: Company
    isUpsertingCompany: boolean
    upsertCompanyDataSuccess: boolean
}

export const CompanyData = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [formValues, setFormValues] = useState<Company | undefined>()
    const [modalConfirmationOpen, setModalConfirmationOpen] = useState<boolean>(false)
    const [modalCancelOpen, setModalCancelOpen] = useState<boolean>(false)
    const [actionButtonClicked, setActionButtonClicked] = useState<boolean>(false)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        company: state.common.company,
        isUpsertingCompany: serviceLoading(state, [UPDATE_COMPANY_DATA_API]),
        upsertCompanyDataSuccess: state.common.updateCompanyDataSuccess,
    }))

    const descriptions = SystemDescriptions.PAGES.SETTINGS.COMPANY_DATA

    const onCancel = () => {
        setModalCancelOpen(true)
    }

    const handleConfirmationAccept = () => {
        setModalConfirmationOpen(false)
        setActionButtonClicked(true)

        if (formValues) {
            dispatch(updateCompanyDataApi(formValues))
        }
    }

    const handleCancelAccept = () => {
        navigate(Urls.FRONTEND.HOME)
    }

    const renderModals = () => (
        <>
            <CancelConfirmationModal
                isVisible={modalConfirmationOpen}
                onAccept={handleConfirmationAccept}
                onCancel={() => {
                    setModalConfirmationOpen(false)
                }}
                title={descriptions.CONFIRM_MODAL.TITLE}
                okText={descriptions.CONFIRM_MODAL.ACTION_BUTTON}
                cancelText={descriptions.CONFIRM_MODAL.CANCEL_BUTTON}
                description={descriptions.CONFIRM_MODAL.DESCRIPTION}
            />
            <CancelConfirmationModal
                isVisible={modalCancelOpen}
                onAccept={handleCancelAccept}
                onCancel={() => { setModalCancelOpen(false) }}
                title={descriptions.CANCEL_MODAL.TITLE}
                okText={descriptions.CANCEL_MODAL.ACTION_BUTTON}
                cancelText={descriptions.CANCEL_MODAL.CANCEL_BUTTON}
                description={descriptions.CANCEL_MODAL.DESCRIPTION}
            />
            <ModalSuccess
                isVisible={(reduxProps.upsertCompanyDataSuccess) && actionButtonClicked}
                title={descriptions.SUCCESS_SECONDARY_MODAL!.TITLE}
                description={descriptions.SUCCESS_SECONDARY_MODAL!.DESCRIPTION}
                onPrimaryAction={handleCancelAccept}
                onSecondaryActiont={handleCancelAccept}
                primaryLabel={descriptions.SUCCESS_SECONDARY_MODAL!.PRIMARY_LABEL}
                secondaryLabel={descriptions.SUCCESS_SECONDARY_MODAL!.SECONDARY_LABEL}
                hideSecondaryButton={true}
            />
        </>
    )

    const renderLoader = () => (
        <Loader
            isVisible={reduxProps.isUpsertingCompany}
            title={descriptions.MAIN_ACTION_TITLE}
            description={descriptions.MAIN_ACTION_DESCRIPTION}
        />
    )

    const onFinish = (company: Company) => {
        setFormValues(company)
        setModalConfirmationOpen(true)
    }

    return (
        <>
            {
                reduxProps.company
                    ? <CompanyForm
                        initialValues={reduxProps.company}
                        onCancel={onCancel}
                        onFinish={onFinish}
                    />
                    : null
            }
            {renderModals()}
            {renderLoader()}
        </>
    )
}
